import { jsx } from 'react/jsx-runtime';
import { useState, useRef, useCallback, useEffect } from 'react';

var styles = {"wrapper":"Ripple-module_wrapper__hUTT1","ripple":"Ripple-module_ripple__KYPTO"};

var interactiveElementSelector = 'a, button';
var Ripple = function (_a) {
    var _b = useState(null), ripple = _b[0], setRipple = _b[1];
    var ref = useRef(null);
    var handlePointerDown = useCallback(function (event) {
        var _a;
        var rippleElement = ref.current;
        if (!rippleElement) {
            return;
        }
        var parent = (_a = rippleElement.parentElement) === null || _a === void 0 ? void 0 : _a.closest(interactiveElementSelector);
        if (!parent) {
            return;
        }
        if (!(event.target instanceof HTMLElement) &&
            !(event.target instanceof SVGElement)) {
            return;
        }
        var interactedWithElement = event.target.closest(interactiveElementSelector);
        if (interactedWithElement !== parent) {
            return;
        }
        if (interactedWithElement instanceof HTMLButtonElement &&
            interactedWithElement.disabled) {
            return;
        }
        var rect = parent.getBoundingClientRect();
        var size = 2 * Math.sqrt(Math.pow(rect.width, 2) + Math.pow(rect.height, 2));
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;
        setRipple({
            id: event.timeStamp,
            size: size,
            x: x,
            y: y,
        });
    }, []);
    useEffect(function () {
        document.body.addEventListener('pointerdown', handlePointerDown);
        return function () {
            document.body.removeEventListener('pointerdown', handlePointerDown);
        };
    }, [handlePointerDown]);
    var discardRipple = useCallback(function () {
        setRipple(null);
    }, []);
    return (jsx("span", { ref: ref, className: styles.wrapper, children: ripple && (jsx("span", { className: styles.ripple, style: {
                '--Ripple-size': "".concat(ripple.size, "px"),
                '--Ripple-x': "".concat(ripple.x, "px"),
                '--Ripple-y': "".concat(ripple.y, "px"),
            }, onAnimationEnd: discardRipple }, ripple.id)) }));
};

export { Ripple };
//# sourceMappingURL=index.mjs.map
